/**
 * Update Banner Component
 *
 * Shows a sticky banner at the top of the screen when the app version is deprecated.
 * User can dismiss (Later) or refresh to update (Refresh Now).
 *
 * Uses the new CDN-based ReleaseConfigService (3-state model).
 */

import { CommonModule } from '@angular/common';
import { Component, computed, Signal } from '@angular/core';
import { SettingsService } from '@app/_services/settings.service';
import { ReleaseConfigService } from '@app/_services/release-config.service';
import { SvgComponent } from '@app/components/shared/svg/svg.component';

@Component({
    selector: 'app-update-banner',
    imports: [CommonModule, SvgComponent],
    templateUrl: './update-banner.component.html',
    styleUrl: './update-banner.component.scss'
})
export class UpdateBannerComponent {

  /** Whether to show the banner (only for deprecated status, not dismissed) */
  showBanner: Signal<boolean> = computed(() => {
    return this.releaseConfigService.versionStatus() === 'deprecated'
      && !this.releaseConfigService.isDismissed();
  });

  constructor(
    public ss: SettingsService,
    private releaseConfigService: ReleaseConfigService,
  ) {}

  /** User clicked "Later" - dismiss the banner for this session */
  onDismiss(): void {
    this.releaseConfigService.dismissDeprecated();
  }

  /** User clicked "Refresh Now" - reload the app to get latest version */
  onRefresh(): void {
    window.location.href = window.location.pathname + '?_cb=' + Date.now();
  }
}
